import { useGetBrandsQuery } from '../../service';

interface UseBrandsProps {
  search?: string;
  page?: number;
  pageSize?: number;
}

const useBrands = ({ search, page = 1, pageSize = 5 }: UseBrandsProps) => {
  const { data, isLoading, error } = useGetBrandsQuery({
    paginated: {
      page,
      pageSize,
    },
    search: search || '',
  });

  return {
    brands: data?.items || [],
    isLoading,
    error,
  };
};

export default useBrands;
